var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullStar(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2969 12.6713L11.6916 14.9081C12.1255 15.194 12.6643 14.7687 12.5355 14.242L11.5547 10.2294C11.5271 10.1176 11.5304 10 11.5641 9.89011C11.5979 9.7802 11.6609 9.68244 11.7457 9.60807L14.7898 6.97303C15.1898 6.62679 14.9834 5.93641 14.4695 5.90173L10.494 5.6334C10.3869 5.62544 10.2842 5.58601 10.1979 5.5197C10.1115 5.4534 10.045 5.36294 10.0062 5.25886L8.52351 1.37574C8.48321 1.26527 8.41154 1.17017 8.31804 1.10305C8.22453 1.03594 8.11361 1 8 1C7.88639 1 7.77547 1.03594 7.68196 1.10305C7.58846 1.17017 7.5168 1.26527 7.47649 1.37574L5.99382 5.25886C5.95497 5.36294 5.88849 5.4534 5.80212 5.5197C5.71576 5.58601 5.61305 5.62544 5.50598 5.6334L1.53052 5.90173C1.01662 5.93641 0.810172 6.62679 1.21016 6.97303L4.2543 9.60807C4.33914 9.68244 4.40207 9.7802 4.43586 9.89011C4.46964 10 4.47291 10.1176 4.44529 10.2294L3.53571 13.9506C3.3812 14.5827 4.0277 15.093 4.54841 14.7499L7.7031 12.6713C7.79183 12.6125 7.89482 12.5813 8 12.5813C8.10518 12.5813 8.20817 12.6125 8.2969 12.6713Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullStar);
export default __webpack_public_path__ + "static/media/full-star.16d1784e2fc406aab53052fec9927cd3.svg";
export { ForwardRef as ReactComponent };